module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/no-free-shipping-icon-4ce856f2733d3532f8be2a9ce921a571.svg";